<style scoped>
/* .status_chip {
  min-width: 100px;
} */
</style>
<template>
  <v-container>
    <v-alert outlined type="error" text class="d-md-none d-lg-none d-xl-none">
      You are viewing a simplified version of the course editor due to your
      screen size. For the full experience, please view this via a desktop.
    </v-alert>
    <div class="flex-sm-wrap">
      <h1 class="display-1 pt-3">Edit {{ course.name || "course" }}</h1>
      <v-spacer />
      <v-switch
        v-model="autoSave"
        label="Auto save"
        hint="Saves progress every 15 seconds"
        persistent-hint=""
        :error="autoSaveError"
        :loading="autoSaveLoading"
        color="green lighten-1"
      ></v-switch>
    </div>
    <!-- <p class="subtitle-2">ID:{{ id }} Type: {{ String(type) }}</p> -->
    <v-row>
      <!-- Course Details -->
      <v-col class="my-2 col-12 col-sm-12 col-md-8">
        <v-card class="pa-4" outlined>
          <h2 class="title ont-weight-bold">Course Details</h2>
          <v-text-field
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="true"
            v-model="course.name"
            label="Name"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="course.author"
            autocomplete="off"
            autocorrect="off"
            spellcheck="true"
            label="Author"
            clearable
          ></v-text-field>
          <v-select
            :items="categories"
            label="Category"
            v-model="course.category"
          ></v-select>
          <v-textarea
            autocomplete="off"
            spellcheck="true"
            name="input-1111-1"
            label="Description"
            v-model="course.description"
            rows="8"
            value
            maxlength="12000"
          ></v-textarea>
        </v-card>
      </v-col>
      <!-- Logo Handling -->
      <v-col class="my-2 col-12 col-sm-12 col-md-4">
        <v-card class="pa-4" outlined height="100%">
          <div class="d-flex">
            <h2 class="title ont-weight-bold align-center">Logo</h2>
            <v-spacer />
            <v-btn
              depressed
              color="blue white--text ml-auto"
              @click="pickimage = true"
            >
              <v-icon left dark>mdi-image</v-icon>
              Browse
            </v-btn>
          </div>

          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="col-12 justify-center align-center">
                <v-img
                  :src="course.imglink"
                  max-height="250"
                  width="100%"
                  contain
                  position="center"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col class="my-2 col-12 col-sm-12 col-md-8">
        <v-card flat="" outlined="" class="pa-4">
          <h2 class="title ont-weight-bold">Activation Message</h2>
          <p>
            This message is sent to learners when they start the course!
          </p>
          <v-textarea
            autocomplete="off"
            spellcheck="true"
            name="input-11131-1"
            placeholder="Custom message"
            v-model="course.activationMessage"
            maxlength="500"
          ></v-textarea>
        </v-card>
      </v-col>
      <v-col class="my-2 col-12 col-sm-12 col-md-4">
        <v-card flat="" outlined="" class="pa-4">
          <h2 class="title ont-weight-bold">Activation Message Preview</h2>
          <p style="white-space: pre-line;">
            {{
              formatActivationText({
                name: course.name,
                custom: course.activationMessage
              })
            }}
          </p>
        </v-card>
      </v-col>
      <v-col class="col-12">
        <v-card class="pa-4" outlined height="100%" min-height="500px">
          <a-l-contenteditor
            :courseid="course._id"
            v-if="!course.__unloaded__"
            :saveindex="saveindex"
            :clearindex="cleared"
            @edited="edited = true"
            @save="onDaySave"
            :type="type"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-scroll-x-reverse-transition>
      <v-btn
        style="z-index: 200"
        min-width="140px"
        dark
        large=""
        color="green"
        :fixed="true"
        bottom
        right
        v-show="edited"
        @click="onSaveAll"
      >
        <v-icon class="mr-2">mdi-content-save-outline</v-icon
        ><span>Save Course</span>
      </v-btn>
    </v-scroll-x-reverse-transition>
    <a-imagemodal
      :dialog="pickimage"
      @close="pickimage = false"
      @finish="onIconPick"
    />
    <a-confirm-modal :dialog="saveError && !$store.getters['needauth']">
      <template slot="headline">
        Error Saving
      </template>
      <template slot="body">
        There was an error saving this course. Please make sure that character
        counts are being honored. If the problem persists, make sure to save
        your work in an outside editor and contact support at support@arist.co
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="red lighten-2 white--text"
          @click="saveError = false"
          >Cancel Save</v-btn
        >
      </template>
    </a-confirm-modal>
  </v-container>
</template>

<script>
import contentEditor from "./components/contenteditor";
import services from "@/services/index.js";
import images from "@/components/imagedisplay-modal";
import confirmmodal from "@/components/confirmation-modal";
import recents from "@/bin/recents";
export default {
  components: {
    "a-l-contenteditor": contentEditor,
    "a-imagemodal": images,
    "a-confirm-modal": confirmmodal
  },
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: "draft"
    }
  },
  data: () => ({
    forced: false,
    autoSave: true,
    autoSaveError: false,
    autoSaveLoading: false,
    autoSaveInterval: null,
    saving: [],
    saveError: false,
    pickimage: false,
    edited: false,
    fab: false,
    saveindex: 0,
    cleared: 0,
    course: {
      __unloaded__: true,
      _id: "",
      name: "",
      author: "",
      imglink: "",
      description: "",
      category: ""
    },
    categories: [
      "",
      "Art & Design",
      "Business",
      "Computer Science",
      "Data Science",
      "Education & Teaching",
      "Engineering",
      "Health & Medicine",
      "Humanities",
      "Mathematics",
      "Programming",
      "Science",
      "Social Sciences"
    ]
  }),
  watch: {
    saving() {
      if (this.saving.length != 0 && !this.saveError && this.forced) {
        this.$store.commit("setLoading", true);
      } else {
        this.forced = false;
        this.$store.commit("setLoading", false);
      }
    },
    course: {
      handler(val, past) {
        if (past.__unloaded__) {
          return;
        }
        console.log("Setting status to: unsaved");
        this.edited = true;
      },
      deep: true
    }
  },
  methods: {
    createAutoSave() {
      this.autoSaveInterval = setInterval(this.autoSaveDocument, 1000 * 15);
    },
    removeAutoSave() {
      if (this.autoSaveInterval) {
        console.log("Removing", this.autoSaveInterval);
        clearInterval(this.autoSaveInterval);
      }
    },
    async autoSaveDocument() {
      /* eslint-disable no-unreachable */
      if (!this.autoSave) {
        return;
      }
      if (!this.course._id) {
        return;
      }
      if (this.course.__unloaded__) {
        return;
      }
      console.log("[AUTOSAVE]", "Starting...");

      this.autoSaveLoading = true;
      try {
        await this.saveCourseDoc();
        await this.saveChildren();
        this.autoSaveError = false;

        console.log("[AUTOSAVE]", "Finished");
      } catch (err) {
        this.autoSaveError = true;
      } finally {
        this.autoSaveLoading = false;
      }
    },
    formatActivationText({ name, custom } = {}) {
      const text = `👋Welcome to ${name}
${custom ? "\n" + custom + "\n\n---\n" : ""}
⏰You'll get your first text at the time that you selected. If you have any trouble with your course, just shoot us a note at support@arist.co.

Your carrier's message and data rates may apply. Reply STOP to pause the course and START to restart.`;
      return text;
    },
    /**
     * Triggered when course cannot be accessed.
     */
    onIconPick(image) {
      this.course.imglink = image.Location;
      this.pickimage = false;
    },
    cannotFindCourse() {},
    /**
     * When the save FAB is clicked, it triggers a save all.
     * Saves all the course data, requests that the days save as well.
     */
    async onSaveAll() {
      this.forced = true;
      this.saving.push("save");
      try {
        await this.saveCourseDoc();
        await this.saveChildren();
        this.edited = false;
      } catch (err) {
        this.edited = true;
        this.saveError = true;
        console.error(err);
      }
      this.saving.pop("save");
    },
    /**
     * Handles saving the actual course meta data.
     * @returns {Boolean} Always true on success.
     */
    async saveCourseDoc() {
      await services.course.update({
        id: this.id,
        coursedoc: this.course,
        type: this.type
      });
      recents.addToRecents({
        name: `Edit ${this.course.name}`,
        path: String(window.location.href)
      });
      return true;
    },
    async onDaySave(data) {
      try {
        let tasks = [];
        /**
         * Clone data to prevent editing source.
         * @type {Array}
         */
        let days = JSON.parse(JSON.stringify(data));
        console.log("Got", days);
        if (days.length == 0) {
          return;
        }
        this.saving.push("save");

        days.forEach(obj => {
          //add the async update to the tasks list.
          tasks.push(
            services.day.update({
              id: this.id,
              did: obj._id,
              daydoc: obj,
              type: this.type
            })
          );
        });
        //Wait for all tasks to be done.
        console.log("tasks", tasks);
        let results = await Promise.all(tasks);
        console.log("Clearing content", results);
        this.cleared = this.cleared + 1;
      } catch (err) {
        console.log(err);
        this.edited = true;
        this.saveError = true;
      }
      this.saving.pop();
    },
    async saveChildren() {
      this.saveindex = this.saveindex + 1;
    },
    /**
     * Loads the course data, direct from source.
     */
    async onLoad() {
      try {
        this.$store.commit("setLoading", true);
        this.course = await services.course.getOne({
          id: this.id,
          type: this.type
        });
        recents.addToRecents({
          name: `Edit ${this.course.name}`,
          path: String(window.location.href)
        });
      } catch (err) {
        this.$store.commit("setLoading", false);
        this.$router.push({ name: "course-notfound" });
        console.error(err);
      }
      this.$store.commit("setLoading", false);
    }
  },
  beforeRouteLeave(to, from, next) {
    console.info("Course Editor, early route leave", this.edited);
    if (!this.edited) {
      next();
      return;
    }
    console.log("asking...");
    const approvedLeave = confirm(
      "Are you sure you want to exit, you have unsaved changes?"
    );
    if (this.edited && approvedLeave) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestroy() {
    this.removeAutoSave();
  },
  mounted() {
    this.onLoad();
    this.createAutoSave();
  }
};
</script>
